<template>
    <div class="rangaistukset">
        <h1>Rangaistustaulukko</h1>
        <p>Tarvittaessa käytetään sovelletusti. Suhteellisuutta antavia rangaistuksia.</p>
        <p>Kolmesta rangaistuksesta automaattisesti 14d bannit. Seuraavista kolmesta varoituksesta permabannit.</p>
        <p>Varoituksen pituudeksi laitetaan aina 180 päivää</p>
        <p>
            Muistuttakaa pelaajia tarkastamaan varoituksiaan. Jos rankaistava pelaaja on palvelimella paikalla, voidaan
            jättää rankaisematta tai lieventää rankaisua, jos pelaaja 'katuu' ja/tai korjaa virheensä.
        </p>
        <p>Opas rangaistuskomentojen käytöstä löytyy Oppaat/Rangaistukset sivulta.</p>
        <p><b>HUOM SUUNTAA ANTAVA, pyritään ylläpidon kesken samoihin linjoihin.</b></p>
        <Rangaistustaulukko />

        <h2>Satunnaista huomoitavaa</h2>
        <ul>
            <li>
                TNT-kanuunat eivät itsessään ole sääntöjä rikkovia, ellei niillä tehty maisemagrief jätetä korjaamatta.
            </li>
        </ul>
    </div>
</template>

<script>
import Rangaistustaulukko from '@/components/Rangaistustaulukko'
import Command from '@/components/Command'

export default {
    name: 'rangaistustaulukko',
    components: {
        Rangaistustaulukko,
        Command
    },
    metaInfo: {
        title: 'Rangaistustaulukko'
    }
}
</script>

<style scoped>
.rangaistukset {
    margin-bottom: 6em;
}
</style>
